export default "/images/web-button-portals-cropped.png?475dda3763a78039f9ac2930b05d1fa7";